import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  useParams,
  NavLink,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import { Tabs, Breadcrumb, Col, Row } from "antd";
import { Link } from "react-router-dom";
import _ from "lodash";
import moment from "moment/moment";
import ProgressBar from "react-bootstrap/ProgressBar";

import Layout from "../layout/Layout";
import Info from "../components/leads-details/Info";
import Notes from "../components/leads-details/Notes";
import Tasks from "../components/leads-details/Tasks";
import Stepsbar from "../components/leads-details/Stepsbar";

import {
  getLeadDetails,
  getLeadTasksStatusList,
  getEmailHistoryByLeadId,
  markAsRead,
} from "../actionCreator/leadDetailsActionCreator";
import {
  getLeadStatusList,
  getLeadRatingList,
} from "../actionCreator/leadListingActionCreater";
import EmailHistory from "../components/leads-details/EmailHistory";
import EmailForm from "../common/EmailForm";
import designation from "../assets/svg/designation.svg";
import company from "../assets/svg/company-name.svg";
import email from "../assets/svg/email-grey.svg";
import phone from "../assets/svg/phone-grey.svg";
import location from "../assets/svg/location.svg";
import hot from "../assets/svg/hot.svg";
import cold from "../assets/svg/cold.svg";
import warm from "../assets/svg/warm.svg";
import { AuthContext } from "../context/AuthContext";

const LeadDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [activeTab, setActiveTab] = useState("1");
  const [stepsList, setStepsList] = useState([]);
  const leadDetail = useSelector(
    (state) => state.LeadDetailsReducer.leadDetails
  );
  const leadNotes = useSelector((state) => state.LeadDetailsReducer.leadNotes);
  const leadRemarks = useSelector(
    (state) => state.LeadDetailsReducer.leadRemarks
  );
  const unreadNotifications = useSelector(
    (state) => state.LeadDetailsReducer.unreadNotifications
  );
  const { isLeadView, isEmailSetupView } = useContext(AuthContext);

  useEffect(() => {
    if (!isLeadView) {
      navigate("/dashboard-view");
    }
  }, [isLeadView, navigate]);

  useEffect(() => {
    if (type === "email") {
      setActiveTab("4");
    }
  }, [type]);

  useEffect(() => {
    const markRead = async (leadId) => {
      await dispatch(markAsRead(leadId));
    };
    if (activeTab === "4") {
      const leadId = parseInt(id);
      const notiClientIds = unreadNotifications?.map((d) => d?.clientLeadId);
      const isUnread = notiClientIds.includes(leadId);
      if (leadId && isUnread) {
        markRead(leadId);
      }
    }
  }, [unreadNotifications, dispatch, id, activeTab]);

  const items = [
    {
      key: "1",
      label: <span className="px-30">Lead Details</span>,
      children: <Info setActiveTab={(tabIndex) => changeTabIndex(tabIndex)} />,
    },
    {
      key: "2",
      label: <span className="px-30">Add Notes</span>,
      children: <Notes setActiveTab={(tabIndex) => changeTabIndex(tabIndex)} />,
    },
    {
      key: "3",
      label: <span className="px-30">Add Tasks</span>,
      children: <Tasks setActiveTab={(tabIndex) => changeTabIndex(tabIndex)} />,
    },
    {
      key: "4",
      label: <span className="px-30">Email</span>,
      children: <EmailHistory />,
    },
  ];

  const changeTabIndex = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  useEffect(() => {
    if (id) {
      dispatch(getLeadDetails(id));
      dispatch(getLeadStatusList());
      dispatch(getLeadRatingList());
      dispatch(getLeadTasksStatusList());
    }
  }, [id, dispatch]);

  const switchToTimeline = () => {
    setActiveTab(`1`);
  };

  useEffect(() => {
    const finalData = [...leadNotes, ...leadRemarks];
    let activityWholeData = [];
    let completedActivityData = [];
    let isMeetingActivity = false;
    if (finalData.length) {
      finalData.forEach((item, index) => {
        let isLeadNote = item?.note ? 1 : 0;
        let title = "";
        if (isLeadNote) {
          title = item.note;
          item.status = "open";
        } else {
          title = item.title;
        }
        if (title === "meeting" || title === "Meeting") {
          isMeetingActivity = true;
        } else {
          activityWholeData.push({
            title: title,
            status: item?.status,
            data: item,
          });
        }
        if (item.status?.trim() === "completed") {
          completedActivityData.push({
            title: title,
            status: item?.status,
            data: item,
          });
        }
      });
    }
    const groupedActivityData = _.groupBy(activityWholeData, "title");
    const groupedActivityCompletedData = _.groupBy(
      completedActivityData,
      "title"
    );
    let totalActivity = Object.keys(groupedActivityData).length;
    let totalClosedActivity = Object.keys(groupedActivityCompletedData).length;
    let totalActicvityPercentage = 0;
    let totalClosedActicvityPercentage = 0;
    if (totalActivity > 0) {
      if (totalActivity >= 5) {
        totalActicvityPercentage = 10;
      } else {
        totalActicvityPercentage = totalActivity * 2;
      }
    }
    if (totalClosedActivity > 0) {
      let perActivityPerc = 5 / totalActivity;
      totalClosedActicvityPercentage = perActivityPerc * totalClosedActivity;
    }
    let statusActivityPercentage = 0;
    if (isMeetingActivity) {
      statusActivityPercentage = 10;
    }
    statusActivityPercentage +=
      totalActicvityPercentage + totalClosedActicvityPercentage;
    let listToRender = [];
    if (Object.keys(leadDetail).length && leadDetail?.status) {
      let stepsCnt = 0;
      if (leadDetail?.status === 11) {
        stepsCnt = 1;
      } else if (leadDetail?.status === 12) {
        stepsCnt = 2;
      } else if (leadDetail?.status === 13) {
        stepsCnt = 3;
      } else if (leadDetail?.status === 14) {
        stepsCnt = 4;
      }
      if (leadDetail?.status === 15) {
        stepsCnt = 5;
      } else {
      }
      let clArray = [
        "primary",
        "secondary",
        "danger",
        "warning",
        "info",
        "success",
      ];
      if (leadDetail?.status === 16) {
        listToRender.push(
          <ProgressBar label="100%" variant={clArray[0]} now={100} key={1} />
        );
      } else if (leadDetail?.status === 17 || leadDetail?.status === 18) {
        listToRender.push(
          <ProgressBar label="0%" variant={clArray[1]} now={0} key={1} />
        );
      } else {
        let totalPercentage = Math.round(
          stepsCnt * 15 + statusActivityPercentage
        );
        if (totalPercentage <= 20) {
          listToRender.push(
            <ProgressBar variant={clArray[2]} now={totalPercentage} key={1} />
          );
        } else if (totalPercentage <= 40) {
          listToRender.push(
            <ProgressBar variant={clArray[3]} now={totalPercentage} key={1} />
          );
        } else if (totalPercentage <= 60) {
          listToRender.push(
            <ProgressBar variant={clArray[5]} now={totalPercentage} key={1} />
          );
        } else {
          listToRender.push(
            <ProgressBar variant={clArray[6]} now={totalPercentage} key={1} />
          );
        }
      }
    }
    setStepsList(listToRender);
  }, [leadDetail, leadNotes, leadRemarks]);

  return (
    <Layout>
      <div id="leads" className="wrapper padd-90">
        <div id="content-wrapper" className="d-flex flex-column">
          <div>
            <Breadcrumb
              separator=""
              items={[
                {
                  title: <Link to="/dashboard-view">Home</Link>,
                },
                {
                  type: "separator",
                },
                {
                  title: <Link to="/search-lead">Search Lead</Link>,
                },
                {
                  type: "separator",
                },
                {
                  title: "Lead details",
                },
              ]}
              className="text-uppercase heading13px"
            />
            <h3 className="mt25 mb20 fw-bold">Leads</h3>
            <Stepsbar />

            <Row
              className="common-box-2 overflow-hidden p-0"
              style={{ width: "100%" }}
            >
              <Col xs={24} lg={7} className="border-right">
                <>
                  {leadDetail?.leadRating === "Hot" && (
                    <div className="d-flex heading12px align-items-center justify-content-end gap-10 text-red fw-semibold p-20">
                      Hot Lead
                      <img src={hot} alt="" />
                    </div>
                  )}
                  {leadDetail?.leadRating === "Cold" && (
                    <div className="d-flex heading12px align-items-center text-cold justify-content-end gap-10 fw-semibold p-20">
                      Cold Lead
                      <img src={cold} alt="" />
                    </div>
                  )}
                  {leadDetail?.leadRating === "Warm" && (
                    <div className="d-flex text-warm heading12px align-items-center justify-content-end gap-10 fw-semibold p-20">
                      Warm Lead
                      <img src={warm} alt="" />
                    </div>
                  )}
                  <div className="profilePic mt40 mb20">
                    <span className="btn btn-dark btn-circle btn-lg text-uppercase">
                      {leadDetail?.firstname?.replace(/\s+/g, " ").trim()?.[0]}
                      {leadDetail?.lastname?.replace(/\s+/g, " ").trim()?.[0]}
                    </span>
                    <h3 className="heading24px mt5 fw-bold">
                      {leadDetail?.fullname}
                    </h3>
                    {leadDetail?.lastModifiedDate && (
                      <div className="heading13px text-gray">
                        Last Activity :
                        {moment(leadDetail?.lastModifiedDate).format(
                          " D MMMM YYYY, h:mm a"
                        )}
                      </div>
                    )}

                    <div className="d-flex align-items-center gap-20 mt20 justify-content-center">
                      {leadDetail?.phoneNo && (
                        <NavLink to={`tel:${leadDetail?.phoneNo}`}>
                          <div className="w-42 h-42 activity-icon heading20px rounded-circle">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18.001"
                              height="18.001"
                              viewBox="0 0 18.001 18.001"
                            >
                              <path
                                id="call-incoming_5070414"
                                d="M17.341,12.6a2.329,2.329,0,0,1,0,3.289l-.685.789C10.5,22.565-4.47,7.6,1.329,1.425L2.193.674A2.315,2.315,0,0,1,5.444.7c.023.023,1.415,1.832,1.415,1.832a2.336,2.336,0,0,1,0,3.217l-.87,1.094a9.6,9.6,0,0,0,5.207,5.218l1.1-.875a2.329,2.329,0,0,1,3.216,0s1.81,1.392,1.833,1.415Zm-1.033,1.092s-1.8-1.384-1.821-1.406a.826.826,0,0,0-1.164,0c-.02.02-1.536,1.228-1.536,1.228a.751.751,0,0,1-.736.114,11.276,11.276,0,0,1-6.63-6.62.751.751,0,0,1,.109-.751S5.739,4.742,5.759,4.723a.826.826,0,0,0,0-1.164c-.023-.023-1.406-1.822-1.406-1.822a.826.826,0,0,0-1.134.029l-.864.751c-4.239,5.1,8.737,17.352,13.2,13.135l.685-.79A.841.841,0,0,0,16.308,13.691Z"
                                transform="translate(-0.019 -0.022)"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <div className="heading13px fw-normal cursor-pointer text-color-6E6E6E">
                            Call
                          </div>
                        </NavLink>
                      )}
                      {isEmailSetupView && (
                        <EmailForm
                          recipientEmail={leadDetail?.emailId}
                          empId={leadDetail?.employeeId}
                          callback={() =>
                            dispatch(getEmailHistoryByLeadId(leadDetail?.id))
                          }
                        >
                          <div className="w-42 h-42 activity-icon rounded-circle">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19.967"
                              height="14.975"
                              viewBox="0 0 19.967 14.975"
                              fill="currentColor"
                            >
                              <g transform="translate(-10.66 -31.98)">
                                <path
                                  d="M29.379,31.98H11.908a1.248,1.248,0,0,0-1.248,1.248V45.707a1.248,1.248,0,0,0,1.248,1.248H29.379a1.248,1.248,0,0,0,1.248-1.248V33.228A1.248,1.248,0,0,0,29.379,31.98Zm-.961,13.727H12.944l4.368-4.517-.9-.867-4.5,4.661V34.176l7.756,7.718a1.248,1.248,0,0,0,1.76,0l7.955-7.912V44.9L24.786,40.31l-.88.88ZM12.725,33.228H28.368l-7.824,7.781Z"
                                  fill="currentColor"
                                />
                              </g>
                            </svg>
                          </div>
                          <div className="heading13px cursor-pointer text-color-6E6E6E">
                            Email
                          </div>
                        </EmailForm>
                      )}
                      <div>
                        <div
                          className="w-42 h-42 activity-icon rounded-circle"
                          onClick={switchToTimeline}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20.218"
                            height="16.702"
                            viewBox="0 0 20.218 16.702"
                            fill="currentColor"
                          >
                            <defs>
                              <clipPath id="clip-path">
                                <rect
                                  width="20.218"
                                  height="16.702"
                                  fill="none"
                                />
                              </clipPath>
                            </defs>
                            <g clipPath="url(#clip-path)">
                              <path
                                d="M218.782,17.755c-.088-.088-.088-.088-.176-.088l-3.868-1.231a2.789,2.789,0,0,0-2.813.616,1.936,1.936,0,0,0-.352.439l-1.758,4.044a1.583,1.583,0,0,0,.176.879,1.513,1.513,0,0,0,1.055.879,1.772,1.772,0,0,0,1.582-.527,1.227,1.227,0,0,0,.264-.352l.615-1.055c.088-.176.264-.352.352-.527.527-.527.7-.264.791-.176.879.791,5.362,5.362,5.362,5.362a.544.544,0,0,1-.088.7.532.532,0,0,1-.7.088l-1.231-1.231a.435.435,0,0,0-.616.615l1.231,1.231a.544.544,0,0,1-.088.7.532.532,0,0,1-.7.088L216.672,26.9a.435.435,0,0,0-.616.615l1.231,1.231a.46.46,0,0,1-.176.7.753.753,0,0,1-.616,0l-1.231-1.231a.435.435,0,1,0-.615.615l1.231,1.231a.461.461,0,0,1-.176.7.751.751,0,0,1-.615,0l-1.582-1.582a.832.832,0,0,0-.176-1.142.854.854,0,0,0-1.231-.088.673.673,0,0,0,.176-1.142.854.854,0,0,0-1.231-.088.942.942,0,0,0-1.318-1.318.849.849,0,0,0-.088-1.231.934.934,0,0,0-1.231-.088l-2.549-2.637a.435.435,0,0,0-.616.615l2.549,2.461-.7.7a.942.942,0,0,0,1.318,1.318.942.942,0,0,0,1.318,1.318.942.942,0,0,0,1.318,1.318.942.942,0,0,0,1.318,1.319l.791-.791,1.582,1.494a1.275,1.275,0,0,0,1.846-.088,1.681,1.681,0,0,0,.439-.879,1.418,1.418,0,0,0,1.318-1.318,1.082,1.082,0,0,0,.879-.439,1.221,1.221,0,0,0,.439-.88,1.081,1.081,0,0,0,.879-.439,1.359,1.359,0,0,0,.088-1.846l-.615-.616,2.637-2.637a.424.424,0,0,0,0-.615Zm6.329.879-3.428-3.429a.851.851,0,0,0-1.231,0l-1.231,1.143a.75.75,0,0,0,0,1.143l3.428,3.428a.85.85,0,0,0,1.231,0l1.231-1.055a.85.85,0,0,0,0-1.231m-1.758,1.758a.7.7,0,1,1,.7-.7.756.756,0,0,1-.7.7"
                                transform="translate(-205.157 -15.03)"
                                fill="currentColor"
                              />
                            </g>
                          </svg>
                        </div>
                        <div className="heading13px cursor-pointer text-color-6E6E6E">
                          Meeting
                        </div>
                      </div>
                      <div>
                        <div className="w-42 h-42 activity-icon rounded-circle">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18.352"
                            height="16.823"
                            viewBox="0 0 18.352 16.823"
                          >
                            <path
                              id="display-code_8778036"
                              d="M13.857,6.26a2.3,2.3,0,0,1,0,3.244L11.881,11.48A.765.765,0,0,1,10.8,10.4l1.975-1.976a.765.765,0,0,0,0-1.081L10.8,5.366a.765.765,0,0,1,1.081-1.081L13.857,6.26Zm-6.3-.895A.765.765,0,0,0,6.471,4.284L4.5,6.26A2.3,2.3,0,0,0,4.5,9.5L6.471,11.48A.765.765,0,0,0,7.552,10.4L5.577,8.423a.765.765,0,0,1,0-1.081L7.552,5.366Zm10.8-.542v6.117a3.828,3.828,0,0,1-3.823,3.823H9.941v1.529H13a.765.765,0,1,1,0,1.529H5.353a.765.765,0,1,1,0-1.529H8.411V14.764H3.823A3.828,3.828,0,0,1,0,10.941V4.823A3.828,3.828,0,0,1,3.823,1H14.529A3.828,3.828,0,0,1,18.352,4.823Zm-1.529,0a2.3,2.3,0,0,0-2.294-2.294H3.823A2.3,2.3,0,0,0,1.529,4.823v6.117a2.3,2.3,0,0,0,2.294,2.294H14.529a2.3,2.3,0,0,0,2.294-2.294Z"
                              transform="translate(0 -1)"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <div className="heading13px cursor-pointer text-color-6E6E6E">
                          Demo
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-top d-flex flex-column gap-20 p-20 heading13px">
                    <div id="leadmeterchart">
                      <ProgressBar>{stepsList}</ProgressBar>
                      <div
                        className={`d-flex justify-content-end fw-bold text-${stepsList[0]?.props?.variant}`}
                      >
                        {stepsList[0]?.props?.now}%
                      </div>
                    </div>

                    <div className="text-black fw-bold">Lead Information</div>
                    {!!leadDetail?.title && (
                      <Row className="text-color-6E6E6E align-items-center">
                        <Col span={1} className="text-center">
                          <img src={designation} alt="" />
                        </Col>
                        <Col span={23} className="pl10">
                          {leadDetail?.title}
                        </Col>
                      </Row>
                    )}
                    {!!leadDetail?.companyName && (
                      <Row className="text-color-6E6E6E align-items-center">
                        <Col span={1} className="text-center">
                          <img src={company} alt="" />
                        </Col>
                        <Col span={23} className="pl10">
                          {leadDetail?.companyName}
                        </Col>
                      </Row>
                    )}
                    {!!leadDetail?.emailId && (
                      <Row className="text-color-6E6E6E align-items-center">
                        <Col span={1} className="text-center">
                          <img src={email} alt="" />
                        </Col>
                        <Col span={23} className="pl10">
                          {leadDetail?.emailId}
                        </Col>
                      </Row>
                    )}

                    {!!leadDetail?.phoneNo && (
                      <Row className="text-color-6E6E6E align-items-center">
                        <Col span={1} className="text-center">
                          <img src={phone} alt="" />
                        </Col>
                        <Col span={23} className="pl10">
                          {leadDetail?.phoneNo}
                        </Col>
                      </Row>
                    )}
                    {!!leadDetail?.website && (
                      <Row className="text-color-6E6E6E align-items-center">
                        <Col span={1} className="text-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20.792"
                            height="20.791"
                            viewBox="0 0 20.792 20.791"
                          >
                            <g
                              id="website_8522275"
                              transform="translate(-2 -2)"
                            >
                              <path
                                id="Path_6"
                                data-name="Path 6"
                                d="M14.752,21.7a.467.467,0,0,0-.064-.194.473.473,0,0,0-.65-.155,3.242,3.242,0,0,1-1.17.449V17.12h.761a.473.473,0,1,0,0-.945h-.761V12.868h1.11a.473.473,0,1,0,0-.945h-1.11V8.615h4.288a16.2,16.2,0,0,1,.437,3.78.472.472,0,0,0,.473.473h3.756a9.182,9.182,0,0,1-.173,1.438.473.473,0,1,0,.925.2,10.175,10.175,0,0,0,.218-2.106,10.4,10.4,0,1,0-10.4,10.4,10.065,10.065,0,0,0,2.2-.238.471.471,0,0,0,.16-.851Zm-2.829.1c-1.72-.284-3.2-2.1-4.022-4.682h4.022Zm0-5.627H7.635a16.058,16.058,0,0,1-.424-3.308h4.712ZM2.969,12.868h3.3a17.123,17.123,0,0,0,.4,3.308H3.74A9.374,9.374,0,0,1,2.969,12.868ZM3.74,8.615H6.664a17.123,17.123,0,0,0-.4,3.308h-3.3A9.374,9.374,0,0,1,3.74,8.615Zm8.183,3.308H7.211a16.058,16.058,0,0,1,.424-3.308h4.288Zm0-8.935V7.67H7.9C8.726,5.085,10.2,3.272,11.923,2.989Zm.945,4.682V2.989c1.72.284,3.2,2.1,4.022,4.682Zm5.26.945h2.924a9.374,9.374,0,0,1,.771,3.308h-3.29a17.039,17.039,0,0,0-.4-3.308Zm2.44-.945H17.883a10.043,10.043,0,0,0-2.244-4.14A9.491,9.491,0,0,1,20.568,7.67ZM9.158,3.529A10.023,10.023,0,0,0,6.908,7.67H4.224A9.489,9.489,0,0,1,9.158,3.529ZM4.224,17.121H6.908a10.025,10.025,0,0,0,2.25,4.142A9.487,9.487,0,0,1,4.224,17.121Z"
                                fill="#6E6E6E"
                              />
                              <path
                                id="Path_7"
                                data-name="Path 7"
                                d="M36.534,28.347l-6.108-2.933a.945.945,0,0,0-1.35.945l.666,6.743a.945.945,0,0,0,1.637.545l.849-.927L33.336,34.3a1.4,1.4,0,0,0,.915.583,1.433,1.433,0,0,0,.249.022,1.408,1.408,0,0,0,.81-.257l.774-.542a1.419,1.419,0,0,0,.348-1.974l-1.108-1.582,1.161-.48a.945.945,0,0,0,.048-1.725ZM34.42,29.9a.473.473,0,0,0-.206.708l1.446,2.064a.474.474,0,0,1-.116.658l-.774.542a.472.472,0,0,1-.658-.116L32.665,31.7a.472.472,0,0,0-.356-.2h-.031a.471.471,0,0,0-.348.154L30.683,33.01l-.666-6.743L36.126,29.2,34.42,29.9Z"
                                transform="translate(-14.279 -12.302)"
                                fill="#6E6E6E"
                              />
                            </g>
                          </svg>
                        </Col>
                        <Col span={23} className="pl10">
                          <Link
                            to={leadDetail?.website}
                            target="_blank"
                            className="text-color-6E6E6E fw-normal"
                          >
                            {leadDetail?.website}
                          </Link>
                        </Col>
                      </Row>
                    )}

                    {!!leadDetail?.address && (
                      <Row className="text-color-6E6E6E align-items-center">
                        <Col span={1} className="text-center">
                          <img src={location} alt="" />
                        </Col>
                        <Col span={23} className="pl10">
                          {leadDetail?.address}
                        </Col>
                      </Row>
                    )}
                  </div>
                </>
              </Col>
              <Col sm={24} lg={17}>
                <Tabs
                  activeKey={activeTab}
                  items={
                    isEmailSetupView
                      ? items
                      : items?.filter((d) => d?.key !== "4")
                  }
                  onChange={(key) => {
                    setActiveTab(`${key}`);
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>

        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>{" "}
        </a>
      </div>
    </Layout>
  );
};

export default LeadDetails;
